import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'antd';

const GroupDetails = ({testDetailsModal, setTestDetailsModal, details}) => {
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        console.log('use effect show modal =====>', testDetailsModal)
        setShowModal(testDetailsModal);
    }, [testDetailsModal]);

  const handleOk = () => {
    setTestDetailsModal(false);
  };

  const handleCancel = () => {
    setTestDetailsModal(false);
  };

  console.log('group details modal ====>', showModal);

  return (
    <>
      <Modal title="Details of this group" open={showModal} onOk={handleOk} onCancel={handleCancel}>
        {details.length>0 && details?.map((item)=>{
            return(
                <div>
                    <p>{item?.testDiff}</p>
                    <p>{item?.testName}</p>
                    <a href={`/assessment-test/edit/${item?.testId}`}>Edit Details</a>
                </div>
            )
        })}
        
      </Modal>
    </>
  );
};

export default GroupDetails;